import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { PRIMARY, DARK } from 'constants/colors';
import { MULTIDRAG_OVERLAY_WIDTH } from 'constants/widths';

import { Box } from '@mui/material';

import { BaseChip } from '../AppointmentChip/Chip.styles';

export const MultiDragOverlay = memo(
  ({
    mousePosition = { x: 0, y: 0 },
    count,
    id,
    hasTransformedSize,
    isDroppedOverlay
  }: {
    mousePosition?: { x: number; y: number };
    count?: number;
    id?: string;
    width?: number;
    hasTransformedSize?: boolean;
    isDroppedOverlay?: boolean;
  }) => {
    const { t } = useTranslation('common');

    const rect = document.getElementById(id || '')?.getBoundingClientRect() || {
      right: 0,
      bottom: 0,
      width: 0,
      height: 0
    };
    const offsetX = mousePosition.x - rect.right + rect.width;
    const offsetY = mousePosition.y - rect.bottom + rect.height;

    return (
      <Box>
        <BaseChip
          id={id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            background: DARK,
            width: `${MULTIDRAG_OVERLAY_WIDTH}px`,
            boxSizing: 'border-box',
            fontSize: '11px',
            padding: '2px',
            color: 'white',
            transform: hasTransformedSize
              ? `translate(${isDroppedOverlay ? 0 : offsetX}px, ${
                  isDroppedOverlay ? 0 : offsetY
                }px)`
              : 'initial'
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              display: 'grid',
              placeItems: 'center',
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              background: PRIMARY
            }}
          >
            {count || 0}
          </Box>
          {t('activityPlanning.selected')}
        </BaseChip>
      </Box>
    );
  }
);
